import { render, staticRenderFns } from "./EmailRedirect.vue?vue&type=template&id=d7193cac&scoped=true&"
import script from "./EmailRedirect.vue?vue&type=script&lang=js&"
export * from "./EmailRedirect.vue?vue&type=script&lang=js&"
import style0 from "./EmailRedirect.vue?vue&type=style&index=0&id=d7193cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7193cac",
  null
  
)

component.options.__file = "EmailRedirect.vue"
export default component.exports